var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDealershipSelected(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 104,
    viewBox: "0 0 116 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2418_52423)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.8891 19.3335H74.1113V25.6668H99.8891V92.1668H74.1113V98.5002H106.334V25.6668C106.334 23.9871 105.655 22.3762 104.446 21.1885C103.237 20.0008 101.598 19.3335 99.8891 19.3335Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.0576 3.5H19.7198C17.9081 3.5 16.1705 4.2073 14.8895 5.46629C13.6084 6.72528 12.8887 8.43285 12.8887 10.2133V98.5H70.8887V10.2133C70.8887 8.43285 70.169 6.72528 68.8879 5.46629C67.6068 4.2073 65.8693 3.5 64.0576 3.5ZM64.4442 92.1667H54.7776V82.6667H28.9998V92.1667H19.3331V10.2133C19.3331 10.1634 19.3431 10.114 19.3625 10.0679C19.382 10.0218 19.4105 9.97992 19.4464 9.94463C19.4823 9.90935 19.5249 9.88135 19.5718 9.86226C19.6187 9.84316 19.669 9.83333 19.7198 9.83333H64.0576C64.1083 9.83333 64.1586 9.84316 64.2055 9.86226C64.2524 9.88135 64.2951 9.90935 64.331 9.94463C64.3669 9.97992 64.3954 10.0218 64.4148 10.0679C64.4342 10.114 64.4442 10.1634 64.4442 10.2133V92.1667Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7773 19.3335H32.2218V25.6668H25.7773V19.3335Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.666 19.3335H45.1105V25.6668H38.666V19.3335Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5547 19.3335H57.9991V25.6668H51.5547V19.3335Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7773 35.1665H32.2218V41.4998H25.7773V35.1665Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.666 35.1665H45.1105V41.4998H38.666V35.1665Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5547 35.1665H57.9991V41.4998H51.5547V35.1665Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7773 51H32.2218V57.3333H25.7773V51Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.666 51H45.1105V57.3333H38.666V51Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5547 51H57.9991V57.3333H51.5547V51Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7773 66.8335H32.2218V73.1668H25.7773V66.8335Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.666 66.8335H45.1105V73.1668H38.666V66.8335Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5547 66.8335H57.9991V73.1668H51.5547V66.8335Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.1113 35.1665H80.5558V41.4998H74.1113V35.1665Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87 35.1665H93.4444V41.4998H87V35.1665Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.1113 51H80.5558V57.3333H74.1113V51Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87 51H93.4444V57.3333H87V51Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.1113 66.8335H80.5558V73.1668H74.1113V66.8335Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87 66.8335H93.4444V73.1668H87V66.8335Z",
    fill: "#FCFCFC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2418_52423"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 116,
    height: 104,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDealershipSelected);
export default __webpack_public_path__ + "static/media/dealership_selected.7f5a1511be49f52ce322df7a061986eb.svg";
export { ForwardRef as ReactComponent };